module.exports = __webpack_public_path__ + "static/media/dna-cta-illustration.74a5be80.svg";